
import Vue from "vue";
import store from "@/store";
import router from "@/router";
import { validationMixin } from "vuelidate";
import AppLoading from "@/components/UI/AppLoading.vue";
import { required, minLength, helpers } from "vuelidate/lib/validators";

// vuelidate rule
const alphaNumAndDashValidator = helpers.regex(
  "alphaNumAndDot",
  /^\/[a-z\d-/]*$/i
);

export default Vue.extend({
  name: "AdminEditCategory",
  mixins: [validationMixin],
  components: { AppLoading },
  data() {
    return {
      id: "",

      isParent: false,

      title: "",
      parent: {} as any,
      parentPath: "",
    };
  },
  computed: {
    categories(): any {
      return store.state.panel.categories.length;
    },
    parentCategories() {
      const categories: any[] = store.state.panel.categories.filter(
        (category: any) => category.parent === null
      );

      const items: any[] = [];

      categories.forEach((category) => {
        items.push({
          title: category.title,
          value: {
            id: category["_id"],
            path: category.parentPath,
          },
        });
      });

      return items;
    },
    titleError(): string[] {
      const errors: string[] = [];
      if (!this.$v.title?.$dirty) {
        return errors;
      }
      !this.$v.title.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    parentPathError(): string[] {
      const errors: string[] = [];
      if (!this.$v.parentPath?.$dirty) {
        return errors;
      }
      !this.$v.parentPath.required && errors.push("تکمیل این فیلد الزامی است");
      !this.$v.parentPath.minLength && errors.push("تکمیل این فیلد الزامی است");
      !this.$v.parentPath.alphaNumAndDashValidator &&
        errors.push(
          "آدرس باید با اسلش (/) شروع شود. کاراکتر های مجاز: حروف، اعداد و خط فاصله (-)"
        );

      return errors;
    },
    isParentValid() {
      if (!this.isParent) {
        if (this.parent !== null) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    isLoading(): boolean {
      return store.state.app.loading;
    },
  },
  methods: {
    setcategoryData(): void {
      const category: any = store.state.panel.categories.find(
        (ctg: any) => ctg._id == this.id
      );

      this.title = category.title;
      this.parent = category.parent;
      this.parentPath = category.parentPath;

      if (this.parent === null) {
        this.isParent = true;
      } else {
        this.isParent = false;
      }
    },
    editCategory(): void {
      const data = {
        title: this.title,
        parent: this.isParent ? null : this.parent.id,
        parentPath: this.parentPath,
      };

      store.dispatch("admin/editCategory", { id: this.id, data });
    },
    backward(): void {
      router.push({ name: "admin-all-categories" });
    },
  },
  mounted() {
    // check route query for category ID
    const categoryId = this.$route.query.id;
    if (categoryId) {
      this.id = categoryId as string;

      // get & set category data id the categories list are gotten
      if (this.categories) {
        this.setcategoryData();
      }
    } else {
      store.commit("app/showSnackbar", {
        message: "لطفا یک دسته‌بندی جهت ویرایش انتخاب کنید",
        status: 400,
      });
      router.push({ name: "admin-all-categories" });
    }
  },
  watch: {
    categories() {
      this.setcategoryData();
    },
    isParent(newVal) {
      if (newVal === true) this.parent = null;
    },
  },
  validations: {
    title: {
      required,
    },
    parentPath: {
      required,
      minLength: minLength(2),
      alphaNumAndDashValidator,
    },
  },
});
